import React from 'react';
import Card from '../../../../components/Card/Card';
import { FormattedMessage } from 'react-intl';
import { Table, Modal, ModalBody, ModalHeader, Button } from 'reactstrap';
import OfferFlowItem from './OfferFlowItem';
import Icon from '../../../../components/Icon/Icon';
import OfferFlowsTableSettings from './TableSettings';
import { LocalStorage } from '../../../../utils/utils';


export default class OfferFlows extends React.Component {

    state = {
        settingsModalOpen: false,
        tableSettings: {}
    }

    componentDidMount = () => {
        const tableSettings = LocalStorage.get('offerFlowTableSettings') ? LocalStorage.get('offerFlowTableSettings') : {
            title: true,
            link: true,
            controls: true,
        };
        this.setState({ tableSettings });
    }

    toggleModal = () => this.setState({ settingsModalOpen: !this.state.settingsModalOpen })

    editSettings = settings => {
        const { settingsModalOpen, tableSettings } = this.state;
        LocalStorage.set('offerFlowTableSettings', { ...tableSettings, ...settings })
        this.setState({ tableSettings: { ...tableSettings, ...settings }, settingsModalOpen: !settingsModalOpen })
    }

    render() {
        const { flows, handleRemoveFlow } = this.props;
        const { settingsModalOpen, tableSettings } = this.state;

        const controls = [<Button color="primary" size="sm" onClick={this.toggleModal} >
            <Icon type='kma-panel' tag='i' />
        </Button>]

        return (
            <Card.WithControls title="navigation.tools.flows.my" defaultMessage="My flows" controls={controls} className='offer-flows' collapsing>
                {/* <Card.Header>
                    <FormattedMessage id='navigation.tools.flows.my' defaultMessage='My flows' />
                </Card.Header> */}
                <Card.Body className='no-padding'>
                    <Table hover striped responsive>
                        <thead>
                            <tr>
                                {tableSettings.title && <th><FormattedMessage id='flows.table.title' defaultMessage='Title' /></th>}
                                {tableSettings.link && <th><FormattedMessage id='flows.table.click-link' defaultMessage='Link' /></th>}
                                {tableSettings.controls && <th></th>}
                            </tr>
                        </thead>
                        <tbody>
                            {flows.map(({ id, link, title }) => (
                                <OfferFlowItem settings={tableSettings} handleRemoveFlow={handleRemoveFlow} key={id} id={id} link={link} title={title} />
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
                <Modal
                    isOpen={settingsModalOpen}
                    toggle={this.toggleModal}
                >
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage id="postback.logs.settings" defaultMessage='Customize fields' />
                    </ModalHeader>
                    <ModalBody>
                        <OfferFlowsTableSettings settings={tableSettings} editSettings={this.editSettings} />
                    </ModalBody>
                </Modal>
            </Card.WithControls>
        )
    }
}